module.exports = __webpack_public_path__ + "img/hr-distractor-robot.12e43601.png";